import axios from 'axios'
import baseURL from '@/plugins/http/baseURL'

export default {
  data: function () {
    return {
      actions: false
    }
  },
  props: {
    accountability: {
      type: Object,
      require: true
    }
  },
  methods: {
    forceFileDownload (response, accountability) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', accountability.description.replace(/\s/g, '') + '.pdf')
      document.body.appendChild(link)
      link.click()
    },
    downloadFile (accountability) {
      axios({
        method: 'post',
        url: baseURL + '/v1/dweller/accountability/download',
        data: {id: accountability.files[0].id},
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.forceFileDownload(response, accountability)
      })
      .catch(() => console.log('error occured'))
    },
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/accountability/index/components/resources/index.js